/**
 * Профессиональные SVG-иконки.
 *
 * Заменяют эмодзи, которые использовались как иконки в navItems.js
 * и PhotoUpload.jsx — бриф это прямо запрещает. Эмодзи к тому же
 * рендерятся по-разному на разных платформах и не наследуют цвет.
 *
 * Все контуры наследуют currentColor и рисуются штрихом 1.6 —
 * единый вес линии по всей системе.
 */

const PATHS = {
  home: 'M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5',
  trips: 'M4 17h16M6 17v-5.5l1.8-4.2A2 2 0 0 1 9.6 6h4.8a2 2 0 0 1 1.8 1.3L18 11.5V17M6 17v2M18 17v2M8.5 13.5h.01M15.5 13.5h.01',
  tasks: 'M9 5h9M9 12h9M9 19h9M4.5 5l1 1 2-2M4.5 12l1 1 2-2M4.5 19l1 1 2-2',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  car: 'M4 16h16M6 16v-5l1.8-4.2A2 2 0 0 1 9.6 5.5h4.8a2 2 0 0 1 1.8 1.3L18 11v5M6 16v2M18 16v2M6 11h12',
  users: 'M8 11a3.2 3.2 0 1 0 0-6.4A3.2 3.2 0 0 0 8 11ZM2.5 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5M16 5.2a3 3 0 0 1 0 5.8M17 14.8c2.3.5 4 2.3 4 4.7',
  chat: 'M20.5 11.5c0 4-3.8 7.2-8.5 7.2a10 10 0 0 1-2.6-.34L4.5 20l1.2-3.3A6.8 6.8 0 0 1 3.5 11.5c0-4 3.8-7.2 8.5-7.2s8.5 3.2 8.5 7.2Z',
  dashboard: 'M4 4h6.5v6.5H4zM13.5 4H20v4H13.5zM13.5 11h6.5v9h-6.5zM4 13.5h6.5V20H4z',
  bell: 'M12 3.5a5.5 5.5 0 0 0-5.5 5.5c0 5-2 6.5-2 6.5h15s-2-1.5-2-6.5A5.5 5.5 0 0 0 12 3.5ZM10.3 19a2 2 0 0 0 3.4 0',
  camera: 'M4 8.5h3l1.5-2h7L17 8.5h3v10H4zM12 16a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM16.5 16.5 21 21',
  filter: 'M4 6h16M7 12h10M10 18h4',
  chevronLeft: 'M14.5 6 8.5 12l6 6',
  chevronRight: 'M9.5 6l6 6-6 6',
  check: 'M5 12.5 9.5 17 19 7.5',
  edit: 'M14.5 5.5 18.5 9.5M4 20l1-4.5L15.5 5a2.1 2.1 0 0 1 3 0l.5.5a2.1 2.1 0 0 1 0 3L8.5 19 4 20Z',
  bold: 'M7 4.5h6a3.5 3.5 0 0 1 0 7H7zM7 11.5h7a3.75 3.75 0 0 1 0 7.5H7z',
  italic: 'M10.5 4.5H18M6 19.5h7.5M14 4.5l-4 15',
  strike: 'M4 12h16M15.5 6.5c-.6-1.5-2-2.2-3.7-2.2-2.2 0-3.8 1.1-3.8 3 0 1.1.6 1.9 1.8 2.5M8.4 17.3c.7 1.4 2.1 2.2 3.9 2.2 2.3 0 3.9-1.2 3.9-3.1 0-.9-.4-1.6-1.1-2.2',
  codeInline: 'M9 6.5 4 12l5 5.5M15 6.5 20 12l-5 5.5',
  listUl: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  listOl: 'M9.5 6h10.5M9.5 12h10.5M9.5 18h10.5M4 4.5h1.2V8M3.8 11h2.1L4 13.7h2M3.8 16h1.7a1 1 0 0 1 0 2H5a1 1 0 0 0 0 2h-1.2',
  quote: 'M5 6.5h6.5v6.5H7A2 2 0 0 1 5 11zM8 13v1.5a3 3 0 0 1-3 3M13 6.5H19.5v6.5H15a2 2 0 0 1-2-2zM16 13v1.5a3 3 0 0 1-3 3',
  table: 'M4 5h16v14H4zM4 10h16M4 14.5h16M9.5 10v9M14.75 10v9',
  minusLine: 'M4 12h16',
  info: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17ZM12 11v5M12 7.5h.01',
  chevronDown: 'M6 9.5l6 6 6-6',
  indent: 'M11 6h9M11 12h9M4 18h16M4 8l3.5 3-3.5 3',
  outdent: 'M11 6h9M11 12h9M4 18h16M7.5 8 4 11l3.5 3',
  alignLeft: 'M4 6h16M4 12h10M4 18h13',
  alignCenter: 'M4 6h16M7 12h10M5.5 18h13',
  alignRight: 'M4 6h16M10 12h10M7 18h13',
  close: 'M6 6l12 12M18 6 6 18',
  plus: 'M12 5v14M5 12h14',
  warning: 'M12 4 2.5 20h19L12 4ZM12 10v4.5M12 17.5h.01',
  wrench: 'M14.5 4.5a4.5 4.5 0 0 0-5.6 5.6L4 15v5h5l4.9-4.9a4.5 4.5 0 0 0 5.6-5.6L17 12l-2.5-.5L14 9l2.5-2.5Z',
  map: 'M9 4 3.5 6.2v13.3L9 17.3m0-13.3 6 2.5m-6-2.5v13.3m6-10.8 5.5-2.2v13.3L15 17.3m0-10.8v10.8',
  fuel: 'M4 20V6a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v14M3 20h11M4 11h9M16 9h2.5a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5V8l-2.5-2.5',
  file: 'M13 3.5H7a1.5 1.5 0 0 0-1.5 1.5v14A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5V9M13 3.5 18.5 9M13 3.5V9h5.5',
  logout: 'M14.5 8V5.5A1.5 1.5 0 0 0 13 4H5.5A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20H13a1.5 1.5 0 0 0 1.5-1.5V16M9.5 12H21m0 0-3-3m3 3-3 3',
  // Режимы сравнения снимков: две колонки рядом, наложение
  // и разворот на всю ширину. Прежде на эти кнопки не было
  // подходящей иконки, и подставлялись чужие по смыслу.
  columns: 'M4 5h6.5v14H4zM13.5 5H20v14h-6.5',
  overlay: 'M4 4h11v11H4zM9 9h11v11H9',
  expand: 'M9.5 4H4v5.5M14.5 4H20v5.5M20 14.5V20h-5.5M4 14.5V20h5.5',
  // Срок, календарь и настройки: до появления сроков и календаря
  // подходящих контуров в наборе не было, и на их месте стояли
  // эмодзи ⏰ и 📍, которые бриф запрещает.
  clock: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17ZM12 7.5V12l3 2',
  calendar: 'M4.5 6.5h15v13h-15zM4.5 10.5h15M8.5 4v4.5M15.5 4v4.5',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5v.2a2 2 0 1 1-4 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1h.2a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1Z',
  link: 'M10 13.5a3.5 3.5 0 0 0 5 0l3-3a3.54 3.54 0 0 0-5-5l-1.7 1.7M14 10.5a3.5 3.5 0 0 0-5 0l-3 3a3.54 3.54 0 0 0 5 5l1.7-1.7',
  // Чат: отправка, вложение, закреп, «Сохранённое», заглушённый диалог,
  // двойная галочка прочтения. До чата этих контуров в наборе не было —
  // на их месте оказались бы эмодзи, которые бриф запрещает.
  send: 'M20 4 3.5 10.5l6.5 2.5M20 4l-5.5 16L11 12.5M20 4 11 12.5',
  paperclip: 'M17.5 11 11 17.5a4 4 0 0 1-5.7-5.7l7.6-7.6a2.7 2.7 0 0 1 3.8 3.8l-7.3 7.3a1.35 1.35 0 0 1-1.9-1.9L13.5 7.5',
  pin: 'M9 4h6l-.6 6.2 2.6 2.3v1.5H7v-1.5l2.6-2.3L9 4ZM12 14v6',
  bookmark: 'M7 4.5h10V20l-5-3.4L7 20V4.5Z',
  bellOff: 'M8.6 5.2A5.5 5.5 0 0 1 17.5 9c0 5 2 6.5 2 6.5h-5M6.7 8.6c-.13.7-.2 1.5-.2 2.4 0 3.4-2 4.5-2 4.5h8M10.3 19a2 2 0 0 0 3.4 0M4 4l16 16',
  checkDouble: 'M2.5 12.5 7 17 16.5 7.5M11 14l3 3L21.5 9.5',
}

export function Icon({ name, size = 20, strokeWidth = 1.6, className = '', title }) {
  const d = PATHS[name]
  if (!d) return null

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : 'true'}
      aria-label={title}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      {d.split('M').filter(Boolean).map((seg, i) => (
        <path key={i} d={`M${seg}`} />
      ))}
    </svg>
  )
}

export const ICON_NAMES = Object.keys(PATHS)
